export const GET_ACTIVITY_PAYMENTS = "admin/GET_ACTIVITY_PAYMENTS";
export const GET_ACTIVITY_PAYMENTS_SUCCESS =
  "admin/GET_ACTIVITY_PAYMENTS_SUCCESS";
export const GET_ACTIVITY_PAYMENTS_FAILURE =
  "admin/GET_ACTIVITY_PAYMENTS_FAILURE";
